"use client";

import type { ComponentPropsWithoutRef } from "react";

import { trackGaEvent } from "@/lib/ga";

type Props = ComponentPropsWithoutRef<"a"> & {
  store: "google_play" | "apple";
};

/** Store badge or download link. Sends click_app_download when followed. */
export function AppDownloadLink({ store, onClick, ...props }: Props) {
  return (
    <a
      {...props}
      target={props.target ?? "_blank"}
      rel={props.rel ?? "noopener noreferrer"}
      onClick={(event) => {
        trackGaEvent("click_app_download", { store });
        onClick?.(event);
      }}
    />
  );
}
